import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { DummyRoomNewItem_EditPage_Query } from "./query";

type Props = {
	hotelID: string;
	roomID: string | undefined;
};

export const useDummyRoomEditQuery = ({ hotelID, roomID }: Props) => {
	const { data } = useCustomSuspenseQuery(DummyRoomNewItem_EditPage_Query, {
		variables: { hotelID, duplicateRoomID: roomID },
		fetchPolicy: "no-cache",
	});

	return data;
};
